import React from 'react';
import './Loading.css';

const Loading = () => {
  return (
    <div className='load-wrapp'>
      <div className='load-3'>
        <div className='line' />
        <div className='line' />
        <div className='line' />
      </div>
    </div>
  );
};

export default Loading;
